module.exports = __webpack_public_path__ + "img/partner_7.db447b4.png";